import React from 'react';
import _ from "underscore";

import './style.scss';

import { partitionBySize } from "../../helper/partition";
import WLFEntity from './wlfEntity';

export default class WLFList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rowCount:props.rowCount
    };
  }

  renderTiles = () => {
    const {collection, onEdit, onClone, onDelete} = this.props;
    const partitionedWLF = partitionBySize(collection, 3);

    return (
      <div className='wlf-list'>
        {
          _.map(partitionedWLF, (row, index) => {
            return(
              <div className='columns' key={index}>
                {
                  _.map(row, (col, key) => {
                    return(
                      <div className='column is-4' key={key}>
                        <WLFEntity
                          wlf={col}
                          onEdit={onEdit}
                          onClone={onClone}
                          onDelete={onDelete}/>
                      </div>
                    )
                  })
                }
              </div>
            )
          })
        }
      </div>
    );
  }

  render() {
    return this.renderTiles();
  }
}